import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export default class MyWallet extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            password: '',
            data: null,
            loading: true,
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/common/get")
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.setState({
                    data: data,
                    loading: false
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    renderForm() {
        return <div className="nk-content ">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <div className="components-preview wide-md mx-auto">
                            <div className="nk-block nk-block-lg">
                                <div className="card card-bordered">
                                    <div className="card-inner">
                                        <div className="nk-order-ovwg-data buy">
                                            <p>موجودی فعلی شما</p>
                                            <div className="amount">{this.money(this.state.data.global.user.balance)} <small className="currenct currency-usd">ریال</small></div>
                                            <div className="flex flex-row mt-4" style={{"gap": "20px"}}>
                                                <div className="btn btn-success"><em className="icon ni ni-arrow-up-left"></em> افزایش موجودی</div>
                                                <div className="btn btn-danger"><em className="icon ni ni-arrow-down-left"></em> درخواست برداشت وجه</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}